import * as React from "react";
import { Button, TextField } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const LoginForm = ({ onLogin }) => {
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  async function handleLogin(e) {
    setIsLoggingIn(true);
    e.preventDefault();
    onLogin({ username, password })
      .then(() => {
        setIsLoggingIn(false);
      })
      .catch(() => {
        setIsLoggingIn(false);
      });
  }

  return (
    <form onSubmit={handleLogin} noValidate>
      <TextField
        label={t("landing.drawer_username")}
        variant='outlined'
        fullWidth
        required
        margin='normal'
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        autoComplete='username'
        autoFocus
      />
      <TextField
        label={t("landing.drawer_password")}
        variant='outlined'
        fullWidth
        required
        margin='normal'
        type='password'
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete='current-password'
      />
      <Button type='submit' fullWidth variant='contained' style={{ marginTop: 24 }}>
        {isLoggingIn ? (
          <div
            style={{
              width: "20px",
              height: "20px",
              border: "2px solid white",
              borderRadius: "50%",
              borderTopColor: "transparent",
              animation: "spin 1s linear infinite",
            }}
          />
        ) : (
          <>
            <span>{t("landing.drawer_login")}</span>
          </>
        )}
      </Button>
    </form>
  );
};

export default LoginForm;
